// extracted by mini-css-extract-plugin
module.exports = {"bannerImage":"ImageSlider_bannerImage__17k-V","noBorder":"ImageSlider_noBorder__36v1F"};